/* ============================================================
   Clown.art — Cart drawer / upsell / qty stepper enhancements
   Étend les Custom Elements <cart-drawer> et <cart-items> de Dawn
   sans les remplacer. Garde compatibilité Section Rendering API.

   Note sécurité : les fragments HTML proviennent de Shopify Section
   Rendering API (notre propre code Liquid serveur), pas d'input user.
   On utilise DOMParser puis replaceChildren() / appendChild() pour
   réinjecter — pas d'innerHTML brut.
   ============================================================ */

(function () {
  'use strict';

  const ROOT = (typeof window !== 'undefined' && window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Dawn updates #cart-icon-bubble only. Reuse its returned section for both
  // header layouts after add/change/remove, without another cart request.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' &&
      !window.__clownCartBubbleSyncInstalled) {
    window.__clownCartBubbleSyncInstalled = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      const html = event && event.cartData && event.cartData.sections &&
        event.cartData.sections['cart-icon-bubble'];
      if (html) applySectionHtml('cart-icon-bubble', html);
    });
  }

  // ============================================================
  // 1. QTY STEPPER (+/- buttons sync the input then trigger change)
  // ============================================================
  // Page panier : .clown-cart-item__qty-*. Tiroir (proposition B) : [data-cr-qty].
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.clown-cart-item__qty-btn, [data-cr-qty]');
    if (!btn) return;
    const stepper = btn.closest('.clown-cart-item__qty-stepper, .cr-line__qty');
    if (!stepper) return;
    const input = stepper.querySelector('.clown-cart-item__qty-input, [data-cr-qty-input]');
    if (!input) return;

    const current = parseInt(input.value, 10) || 0;
    const isMinus = btn.classList.contains('clown-cart-item__qty-btn--minus') || btn.getAttribute('data-cr-qty') === 'minus';
    const next = isMinus ? Math.max(0, current - 1) : current + 1;

    if (next === current) return;
    input.value = next;
    // Dispatch change so Dawn's <cart-items> custom element picks it up
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ============================================================
  // 2. UPSELL LOADER : fetch /recommendations on cart drawer render
  // ============================================================
  // ------------------------------------------------------------
  // 2a. « SOUVENT AJOUTÉ » du tiroir (Figma 710:1585)
  // Source : recommandations Shopify du produit (complementary puis related),
  // premier produit disponible absent du panier. Construit en DOM (textContent),
  // mis en cache par produit pour que les re-rendus du tiroir ne clignotent pas.
  // ------------------------------------------------------------
  const recoCache = {};
  // Reprend le format du filtre Liquid `money` du marché courant à partir d'un
  // échantillon rendu côté serveur (123456 → « 1 234,56 € », « CHF 1,234.56 »…).
  function formatMoney(cents, sample) {
    const m = sample && sample.match(/1(\D?)234(\D)56/);
    if (m) {
      const fixed = (cents / 100).toFixed(2).split('.');
      const int = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, m[1]);
      return sample.replace(m[0], int + m[2] + fixed[1]);
    }
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' ' + currency;
    }
  }
  function fetchReco(productId, exclude) {
    const cacheKey = productId + '|' + exclude.join(',');
    if (recoCache[cacheKey] !== undefined) return Promise.resolve(recoCache[cacheKey]);
    const base = ROOT + 'recommendations/products.json?limit=6&product_id=' + encodeURIComponent(productId);
    const pick = function (data) {
      const list = (data && data.products) || [];
      for (let i = 0; i < list.length; i++) {
        const p = list[i];
        const v = (p.variants || []).find(function (x) { return x.available; });
        if (p.available && v && exclude.indexOf(String(p.id)) === -1) return { p: p, v: v };
      }
      return null;
    };
    const get = function (intent) {
      return fetch(base + '&intent=' + intent, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(pick)
        .catch(function () { return null; });
    };
    return get('complementary')
      .then(function (hit) { return hit || get('related'); })
      .then(function (hit) { recoCache[cacheKey] = hit; return hit; });
  }
  function renderReco(box, hit) {
    if (!hit) { box.hidden = true; return; }
    const p = hit.p, v = hit.v;
    const img = p.featured_image || (p.images && p.images[0]);
    const media = document.createElement('a');
    media.className = 'cr-cart__reco-media';
    media.href = p.url; media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');
    if (img) {
      const im = document.createElement('img');
      // Affichée 48 × 48 en cover : source carrée 96 (2×) et 144 (3×).
      const raw = typeof img === 'string' ? img : img.src;
      const sized = function (px) { return raw + (raw.indexOf('?') === -1 ? '?' : '&') + 'width=' + px + '&height=' + px + '&crop=center'; };
      im.src = sized(96);
      im.srcset = sized(96) + ' 2x, ' + sized(144) + ' 3x';
      im.width = 48; im.height = 48; im.alt = ''; im.loading = 'lazy';
      media.appendChild(im);
    }
    const copy = document.createElement('div');
    copy.className = 'cr-cart__reco-copy';
    const label = document.createElement('span');
    label.className = 'cr-cart__label'; label.textContent = window.clownI18n.message_11;
    const name = document.createElement('a');
    name.className = 'cr-cart__reco-name'; name.href = p.url;
    name.textContent = p.title + ' · ' + formatMoney(v.price, box.getAttribute('data-money-sample'));
    copy.appendChild(label); copy.appendChild(name);
    const form = document.createElement('form');
    form.className = 'cr-cart__reco-form';
    form.method = 'post'; form.action = ROOT + 'cart/add';
    form.setAttribute('data-clown-upsell-add', '');
    const id = document.createElement('input');
    id.type = 'hidden'; id.name = 'id'; id.value = v.id;
    const qty = document.createElement('input');
    qty.type = 'hidden'; qty.name = 'quantity'; qty.value = '1';
    const btn = document.createElement('button');
    btn.type = 'submit'; btn.className = 'cr-cart__reco-add';
    btn.textContent = window.clownI18n.message_12;
    btn.setAttribute('aria-label', window.clownI18n.add_product.replace('[product]', p.title));
    form.appendChild(id); form.appendChild(qty); form.appendChild(btn);
    box.replaceChildren(media, copy, form);
    box.hidden = false;
  }
  function loadCartReco() {
    document.querySelectorAll('[data-cr-cart-reco]').forEach(function (box) {
      if (box.childElementCount) return;
      const pid = box.getAttribute('data-product-id');
      if (!pid) return;
      const exclude = (box.getAttribute('data-exclude') || '').split(',').filter(Boolean);
      fetchReco(pid, exclude).then(function (hit) {
        if (box.isConnected) renderReco(box, hit);
      });
    });
  }

  function loadUpsell() {
    loadCartReco();
    const upsellContainers = document.querySelectorAll('[data-clown-cart-upsell]');
    upsellContainers.forEach(function (container) {
      const upsellEl = container.querySelector('.clown-upsell');
      if (!upsellEl) return;
      const productId = upsellEl.getAttribute('data-clown-upsell-product-id');
      const limit = parseInt(upsellEl.getAttribute('data-clown-upsell-limit'), 10) || 3;
      if (!productId) return;

      const content = upsellEl.querySelector('[data-clown-upsell-content]');
      // Skip if already populated with real cards
      if (content && content.querySelector('.clown-upsell__card')) return;

      const url = ROOT + 'recommendations/products?product_id=' + encodeURIComponent(productId) +
                  '&limit=' + limit + '&intent=related&section_id=clown-upsell-fragment';
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const cards = doc.querySelectorAll('.clown-upsell__card');
          if (cards.length === 0) {
            upsellEl.hidden = true;
            return;
          }
          if (content) {
            content.replaceChildren.apply(content, Array.from(cards));
          }
        })
        .catch(function () {
          if (upsellEl) upsellEl.hidden = true;
        });
    });
  }

  // ------------------------------------------------------------
  // Recharge des upsells après un RE-RENDU du drawer
  // ------------------------------------------------------------
  // Dawn réécrit tout le contenu du drawer à chaque changement de quantité :
  // les cartes d'upsell sont alors remplacées par les squelettes rendus côté
  // serveur. `loadUpsell` n'étant appelée qu'à l'OUVERTURE, les squelettes
  // restaient affichés indéfiniment (drawer déjà ouvert). On observe donc le
  // contenu et on relance le chargement dès que des squelettes réapparaissent.
  let upsellObserver = null;
  function watchUpsellRerender(drawer) {
    if (upsellObserver || typeof MutationObserver === 'undefined') return;
    upsellObserver = new MutationObserver(function () {
      const stale = document.querySelector(
        '[data-clown-cart-upsell] [data-clown-upsell-content] .clown-upsell__card-skeleton, [data-cr-cart-reco]:empty'
      );
      if (stale) requestAnimationFrame(loadUpsell);
    });
    upsellObserver.observe(drawer, { childList: true, subtree: true });
  }

  // ============================================================
  // 3. AJAX ADD-TO-CART (upsell + sticky-atc forms)
  // ============================================================
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form.matches && (form.matches('[data-clown-upsell-add]') || form.matches('[data-clown-sticky-atc-form]')))) return;
    // Un form enveloppé dans <product-form> est déjà géré par Dawn product-form.js :
    // traiter ici aussi = DOUBLE ajout au panier (bug kit ×2 du 6 juil.).
    if (form.closest && form.closest('product-form')) return;
    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');
    /* États annoncés : le libellé change en plus de l'apparence, sinon un
       lecteur d'écran n'apprend rien de l'ajout en cours ni de sa réussite. */
    const labelEl = submitBtn && submitBtn.querySelector('.clown-sticky-atc__cta-label');
    const labelHtml = labelEl ? labelEl.innerHTML : null;
    const statusEl = form.closest('clown-sticky-atc')
      ? form.closest('clown-sticky-atc').querySelector('[data-sticky-atc-status]')
      : null;
    if (statusEl) statusEl.textContent = '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      submitBtn.setAttribute('aria-busy', 'true');
      if (labelEl) labelEl.textContent = window.clownI18n.message_1;
    }

    const formData = new FormData(form);
    if (!formData.get('sections')) {
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
    }

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: formData,
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || data.message || 'Cart error');
        }

        if (data.sections) {
          Object.keys(data.sections).forEach(function (sectionId) {
            applySectionHtml(sectionId, data.sections[sectionId]);
          });
        }

        if (labelEl) labelEl.textContent = window.clownI18n.message_3;
        if (submitBtn) submitBtn.classList.add('is-added');

        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      })
      .catch(function (err) {
        console.error('[clown-cart] Add error:', err);
        /* Message lisible plutôt qu'un échec silencieux, et le bouton
           redevient utilisable : une erreur réseau ne doit pas bloquer
           définitivement l'achat. */
        if (statusEl) {
          statusEl.textContent = window.clownI18n.message_6;
        }
        if (labelEl && labelHtml !== null) labelEl.innerHTML = labelHtml;
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          submitBtn.removeAttribute('aria-busy');
        }
        /* Retour au libellé d'origine après le message de succès : la barre
           doit rester réutilisable si le visiteur referme le panier. */
        if (labelEl && labelHtml !== null) {
          window.setTimeout(function () {
            labelEl.innerHTML = labelHtml;
            if (submitBtn) submitBtn.classList.remove('is-added');
          }, 2000);
        }
      });
  });

  function applySectionHtml(sectionId, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    if (sectionId === 'cart-drawer') {
      const newInner = doc.querySelector('cart-drawer .clown-cart-drawer__panel, cart-drawer .drawer__inner');
      const currentInner = document.querySelector('cart-drawer .clown-cart-drawer__panel, cart-drawer .drawer__inner');
      if (newInner && currentInner) {
        currentInner.replaceChildren.apply(currentInner, Array.from(newInner.childNodes));
      }
      const newCD = doc.querySelector('cart-drawer');
      const curCD = document.querySelector('cart-drawer');
      if (newCD && curCD) {
        if (newCD.classList.contains('is-empty')) curCD.classList.add('is-empty');
        else curCD.classList.remove('is-empty');
      }
    } else if (sectionId === 'cart-icon-bubble') {
      const newBubble = doc.querySelector('.clown-cart-pill-bubble');
      if (!newBubble) return;
      ['cart-icon-bubble', 'cart-icon-bubble-desktop'].forEach(function (id) {
        const cur = document.getElementById(id);
        if (cur) {
          const clone = newBubble.cloneNode(true);
          cur.replaceChildren.apply(cur, Array.from(clone.childNodes));
        }
      });
    }
  }

  // ============================================================
  // 3b. SYNC DRAWER APRÈS UN AJOUT PAR L'APP VEX (Auto Add To Cart)
  // Vex ajoute le cadeau via son propre fetch `/cart/add.js?vex=true`, APRÈS que
  // notre drawer s'est rafraîchi sur l'ajout du produit principal → la box
  // n'apparaissait que dans le checkout (constat Diego 22/08).
  // Stratégie : on NE patche PAS window.fetch (fragile : d'autres apps — Powl
  // « shop-cart-sync » — le remplacent après nous et court-circuitent le hook ;
  // constaté sur la LP Étendu). On observe à la place les requêtes réseau via
  // PerformanceObserver : dès qu'un appel `/cart/add` porteur de `vex=true`
  // termine, on re-rend le drawer via la Section Rendering API.
  // Fallback : si PerformanceObserver est absent, on compare item_count
  // après chaque ouverture du drawer.
  // ============================================================
  (function syncDrawerAfterVex() {
    if (window.__clownVexSyncInstalled) return;
    window.__clownVexSyncInstalled = true;
    let pending = null;
    let lastCount = null;

    function refreshDrawer() {
      if (pending) return;
      pending = fetch(ROOT + '?sections=cart-drawer,cart-icon-bubble', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          Object.keys(sections || {}).forEach(function (id) {
            if (sections[id]) applySectionHtml(id, sections[id]);
          });
        })
        .catch(function () { /* silencieux : le checkout reste juste */ })
        .finally(function () { pending = null; });
    }

    // Voie 1 : PerformanceObserver — voit TOUTES les requêtes, quel que soit
    // l'auteur (fetch, XHR) et quel que soit l'ordre de chargement des apps.
    if ('PerformanceObserver' in window) {
      try {
        const po = new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (entry) {
            const u = entry.name || '';
            if (u.indexOf('/cart/add') !== -1 && u.indexOf('vex=true') !== -1) {
              setTimeout(refreshDrawer, 200);
            }
          });
        });
        po.observe({ type: 'resource', buffered: false });
      } catch (e) { /* on retombe sur la voie 2 */ }
    }

    // Voie 2 : filet de sécurité — à chaque ouverture du drawer, on compare le
    // nombre d'articles réel à celui affiché ; s'ils divergent, on re-rend.
    document.addEventListener('clown:cart:opened', function () {
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          const shown = document.querySelectorAll('cart-drawer [data-cr-line], cart-drawer .cart-item, cart-drawer [class*="line-item"]').length;
          if (cart.item_count !== lastCount || (shown && cart.items.length !== shown)) {
            lastCount = cart.item_count;
            if (cart.items.length !== shown) refreshDrawer();
          }
        })
        .catch(function () {});
    });
  })();

  // ============================================================
  // 3c. PASSE AU COMPLET (tiroir, Figma 710:1562)
  // Action explicite du client uniquement : remplace la ou les unités du Kit
  // Essentiel par autant de Kits Créatifs Complets, en une seule requête
  // /cart/update.js. Le tiroir et le compteur de la nav sont re-rendus depuis
  // les sections renvoyées par Shopify, puis cartUpdate est publié.
  // ============================================================
  let upgradeBusy = false;
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-cr-cart-upgrade-btn]');
    if (!btn || upgradeBusy) return;
    const box = btn.closest('[data-cr-cart-upgrade]');
    if (!box) return;
    const from = box.getAttribute('data-from');
    const to = box.getAttribute('data-to');
    const qty = parseInt(box.getAttribute('data-qty'), 10) || 1;
    if (!from || !to) return;

    const status = box.querySelector('[data-cr-cart-upgrade-status]');
    const label = btn.querySelector('[data-cr-cart-upgrade-label]');
    const labelText = label ? label.textContent : '';
    upgradeBusy = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = window.clownI18n.message_13;
    if (status) status.textContent = '';

    const updates = {};
    updates[from] = 0;
    updates[to] = qty;

    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || (data && data.status && data.status !== 200)) {
            throw new Error((data && (data.description || data.message)) || 'update');
          }
          return data;
        });
      })
      .then(function (data) {
        if (data.sections) {
          Object.keys(data.sections).forEach(function (id) {
            if (data.sections[id]) applySectionHtml(id, data.sections[id]);
          });
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'clown-cart-upgrade', cartData: data });
        }
        const live = document.getElementById('CartDrawer-LiveRegionText');
        if (live) live.textContent = window.clownI18n.message_14;
        const panel = document.querySelector('cart-drawer .drawer__inner');
        if (panel) panel.focus({ preventScroll: true });
      })
      .catch(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (label) label.textContent = labelText;
        if (status) status.textContent = window.clownI18n.message_15;
      })
      .finally(function () { upgradeBusy = false; });
  });

  // ============================================================
  // 4. ENHANCE <cart-drawer> open/close (scroll-lock, ESC, overlay click)
  // ============================================================
  function enhanceCartDrawer() {
    if (!window.customElements || !window.customElements.get('cart-drawer')) {
      return setTimeout(enhanceCartDrawer, 50);
    }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const origOpen = drawer.open ? drawer.open.bind(drawer) : null;
    let settleTimer = null;
    drawer.open = function (triggeredBy) {
      const wasOpen = drawer.classList.contains('is-open');
      document.documentElement.style.overflow = 'hidden';
      drawer.classList.add('is-open');
      drawer.classList.add('active');
      if (origOpen) origOpen(triggeredBy);
      requestAnimationFrame(loadUpsell);
      watchUpsellRerender(drawer);
      // Cascade d'entrée jouée une fois par ouverture ; les re-rendus suivants
      // (quantité, ajout depuis le tiroir) s'affichent sans rejouer l'animation.
      if (!wasOpen) {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () { drawer.classList.add('is-settled'); }, 1200);
      }
      // Filet de focus : Dawn piège le focus sur « transitionend » ; si aucune
      // transition ne tourne (mouvement réduit), on place le focus nous-mêmes.
      setTimeout(function () {
        if (drawer.classList.contains('is-open') && !drawer.contains(document.activeElement)) {
          const panel = drawer.querySelector('.drawer__inner');
          if (panel) panel.focus({ preventScroll: true });
        }
      }, 700);
      // Signal pour le filet de sécurité Vex (bloc 3b) : vérifie la cohérence
      // articles réels / articles affichés à chaque ouverture.
      document.dispatchEvent(new CustomEvent('clown:cart:opened'));
    };

    const origClose = drawer.close ? drawer.close.bind(drawer) : null;
    drawer.close = function () {
      document.documentElement.style.overflow = '';
      drawer.classList.remove('is-open');
      drawer.classList.remove('active');
      clearTimeout(settleTimer);
      drawer.classList.remove('is-settled');
      if (origClose) origClose();
    };

    drawer.addEventListener('click', function (e) {
      if (e.target && e.target.matches && e.target.matches('#CartDrawer-Overlay, .cr-cart__overlay, .clown-cart-drawer__overlay')) {
        drawer.close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        drawer.close();
      }
    });

    // Quand drawer ouvert, le drawer (position:fixed inset:0, pointer-events:auto)
    // couvre toute la page → un clic sur le hamburger est physiquement intercepté
    // par l'overlay du drawer même si le burger est visible. Pour qu'un seul clic
    // ferme le drawer ET ouvre le menu, on intercepte le clic en phase capture,
    // on identifie si la cible RÉELLE (sous l'overlay) est un toggle de menu via
    // elementsFromPoint, puis on ferme le drawer et on re-déclenche un click sur
    // le toggle. Sans ça, l'utilisateur doit cliquer deux fois.
    document.addEventListener('click', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      // Cas 1 : le clic touche directement un toggle (rare, mais ok)
      var direct = e.target && e.target.closest && e.target.closest('[data-clown-menu-toggle], #menu-drawer-button, .header__icon--menu');
      if (direct) {
        drawer.close();
        return;
      }
      // Cas 2 : le clic touche l'overlay/drawer, mais sous le point cliqué se trouve un toggle.
      // On vérifie via elementsFromPoint pour le détecter et re-déclencher le clic.
      if (!document.elementsFromPoint) return;
      var stack = document.elementsFromPoint(e.clientX, e.clientY);
      var hiddenToggle = null;
      for (var i = 0; i < stack.length; i++) {
        var el = stack[i];
        if (el.closest && el.closest('[data-clown-menu-toggle], #menu-drawer-button, .header__icon--menu')) {
          hiddenToggle = el.closest('[data-clown-menu-toggle], #menu-drawer-button, .header__icon--menu');
          break;
        }
      }
      if (hiddenToggle) {
        e.stopPropagation();
        e.preventDefault();
        drawer.close();
        // Re-déclencher le clic sur le toggle après que le drawer se ferme
        setTimeout(function () {
          hiddenToggle.click();
        }, 50);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceCartDrawer);
  } else {
    enhanceCartDrawer();
  }

  // ============================================================
  // Illustration du panier vide (1,3 Mo, 17.10.2026) : chargée seulement
  // quand le tiroir est ouvert. Le tiroir est re-rendu par la Section
  // Rendering API, d'où l'observation du sous-arbre et pas d'un seul nœud.
  // ============================================================
  function watchDrawerArt() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.crArtWatch) return;
    drawer.dataset.crArtWatch = 'true';
    const hydrate = function () {
      if (!drawer.classList.contains('active')) return;
      drawer.querySelectorAll('img[data-cr-src]').forEach(function (img) {
        img.src = img.dataset.crSrc;
        img.removeAttribute('data-cr-src');
      });
    };
    new MutationObserver(hydrate).observe(drawer, {
      attributes: true, attributeFilter: ['class'], childList: true, subtree: true
    });
    hydrate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerArt);
  } else {
    watchDrawerArt();
  }
})();
